'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Checkbox', []).directive('rmCheckbox', require('./directives/CheckboxDirective'));